import { Action, Dispatch } from 'redux'
import { isBefore, format, startOfMonth } from 'date-fns'
import { FirebaseDocRefType } from 'firebase/index'
import { StoreCalendarType } from 'types/storeCalendar'
import { setStoreCalendarsAction } from 'reducks/storeCalendar/actions'

const fetchStoreCalendars = (storeRef: FirebaseDocRefType, startOfCurrentMonth: Date) => {
  return async (dispatch: Dispatch<Action>) => {
    const calendarsRef = storeRef.collection('store_calendars')

    // 当月以降の店舗カレンダーを取得する
    const today = new Date()
    const start = isBefore(startOfCurrentMonth, today) ? startOfCurrentMonth : startOfMonth(today)

    const calendars = await calendarsRef
      .orderBy('date', 'asc')
      .startAt(format(start, 'yyyyMMdd'))
      .get()
      .then((snapshots) => {
        const _calendars: StoreCalendarType[] = []
        snapshots.forEach((snapshot) => {
          const data = snapshot.data() as StoreCalendarType
          _calendars.push(data)
        })
        return _calendars
      })
      .catch((error) => {
        console.error(error)
        return []
      })

    dispatch(setStoreCalendarsAction(calendars))
  }
}

export default fetchStoreCalendars
